<div class="editor">
  <div class="form">
    <div class="row">
      <app-text-field class="width-100" [label]="'Command'" [length]="200" [mode]="Mode.edition" [required]="true"
        [(value)]="command"></app-text-field>
    </div>
  </div>
  <app-form-buttons domain="AFTER_SALES" [mode]="Mode.edition" [valid]="command > ' '" (event)="onEvent($event)"></app-form-buttons>
</div>
